import ProjectSeparator from "@/components/pages/Community/ProjectSeparator/ProjectSeparator";

export default ProjectSeparator;
